import React, { useEffect, useState, forwardRef, useImperativeHandle, useCallback, useMemo } from 'react';
import style from '../../Styles/Order/OrderSummary.module.css'
import { ApiCallerConnection } from '../../Api/ApiCallerConnection';
import { Form } from 'react-bootstrap';
import Enum from '../../Common/Enum/Enum';

const OrderSummary = ({ idOrderParam }) => {
  
    const [formData, setFormData] = useState({        
        status: '',
        firstName: '',
        lastName: '',
        adresse: '',
        orderComments: '',
        totalprice : '' ,
        orderDetail : []  
    });

    const [hasCalledApi, setHasCalledApi] = useState(false);

    const [apiState, setApiState] = useState({
        loading: true,
        apiData : null,
        error: null
      });
      
    const idOrderObject = useMemo(() => ({
        idOrder: idOrderParam
    }), [idOrderParam]);

    const updateApiState = useCallback((updates) => {
        setApiState(prev => ({ ...prev, ...updates }));
    }, []);

    
    const updateFormField = useCallback((field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
      }, []);

 
    useEffect(() => {
        if (apiState.apiData) {
            setFormData(prev => ({
            ...prev,
            status: apiState.apiData.status || '',
            firstName: apiState.apiData.firstName || '',
            lastName: apiState.apiData.lastName || '',
            adresse: apiState.apiData.adresse || '',
            orderComments: apiState.apiData.orderComments || '',
            totalprice : apiState.apiData.totalprice || '',
            orderDetail : apiState.apiData.orderDetail || []             
          }));
          setApiState(prev => ({ ...prev, loading: false }));
        }
    }, [apiState.apiData]); 


    const FormInput = useCallback(({ value, field }) => (
        <Form.Control
          as="textarea"          
          className={`${style.personalInput} ${style.commonInput}`}
          value={value} 
          readOnly        
          translate="no"
        />
      ), []);

      const OrderDetailItem = ({ item }) => (
        <div className="order-detail-item" style={{ 
          display: 'flex', 
          gap: '20px', 
          marginBottom: '15px',
          padding: '10px',
          borderBottom: '1px solid #eee'
        }}>
          <div style={{ flex: '0 0 100px' }}>
            <img src={item.imagePath} alt={item.productDescription} style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
          </div>
          <div style={{ flex: 1 }}>
            <div><strong>{item.productDescription}</strong></div>
            <div>Cantidad: {item.quantity}</div>
            <div>Precio: Q.{item.linePrice}</div>
            <div style={{ fontSize: '0.9em', color: '#667' }}>{item.comments}</div>
          </div>
        </div>
      );

      const statusMap = {
        1: "Creada",
        2: "Cocinando",
        3: "En ruta",
        4: "Entregada",
        5: "Cancelada",
        6: "Cerrada"
      };

    const orderSummaryForm = useMemo(() => {
        return (
            <div className={style.mainContainer}>
                <div className={style.formContainer}>
                    <div>                     
                         <FormInput value={"Nombre: "+formData.firstName+" "+formData.lastName} field="lastName" />                                           
                    </div>                                
                                      
                    <div>
                        <FormInput value={"Dirección: "+formData.adresse} field="adresse" />
                    </div>
                    <div>
                        <FormInput value={"Estado: " + formData.status} field="status" />
                    </div>
                    <div>
                        <FormInput value={formData.orderComments} field="orderComments" />
                    </div>
                    <div>
                        <FormInput value={"Total : "+"Q."+formData.totalprice} field="totalprice" />
                    </div>                                    
                </div>
              
                <div className={style.orderDetailContainer}>
                    {formData.orderDetail && formData.orderDetail.length > 0 && (
                      <div>
                        <h5>Detalle de la orden:</h5>
                        {formData.orderDetail.map((item, index) =>  (
                          <OrderDetailItem key={index} item={item} />
                        ))               }
                      </div>
                    )}
                </div>                                 
                               
            </div>
        );
    }, [formData]); 

    return (
        <div>
            <ApiCallerConnection method={process.env.REACT_APP_API_POST} url={process.env.REACT_APP_API_POST_GETORDERBYID} useAuth={false} data={idOrderObject}>
                {(response) => {
                    if (response.dataResponse && !apiState.apiData && !hasCalledApi) {
                        setHasCalledApi(true);  
                        setTimeout(() => updateApiState({ apiData: response.dataResponse }), 0);  
                    }
                    if (response.error && !apiState.error) {
                        setTimeout(() => updateApiState({ error: response.error }), 0);
                    }
                    return orderSummaryForm;
                }}
            </ApiCallerConnection>
        </div>
    )
}

export default OrderSummary